"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const styles = __importStar(require("../search/Search.css"));
const Label_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Label"));
const SearchContextType_1 = require("../search/SearchContextType");
const ControlledComboboxFilter_1 = __importDefault(require("./combo-box-filter/ControlledComboboxFilter"));
const ControlledDatePickerFilter_1 = __importDefault(require("./date-picker-filter/ControlledDatePickerFilter"));
const ControlledCheckboxFilter_1 = __importDefault(require("./checkbox-filter/ControlledCheckboxFilter"));
const ControlledMultiSelectCombobox_1 = __importDefault(require("./multi-select-combo-box-filter/ControlledMultiSelectCombobox"));
const ControlledCustomFilter_1 = __importDefault(require("./custom-filter/ControlledCustomFilter"));
const constants = __importStar(require("../search/constants"));
const constants_1 = require("../constants");
const CustomComponent_1 = __importDefault(require("./custom-component/CustomComponent"));
const ControlledOptionGroup_1 = __importDefault(require("./option-group/ControlledOptionGroup"));
function checkAppliedChanges(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
}
const ControlledFilter = (props) => {
    const { state } = (0, react_1.useContext)(SearchContextType_1.SearchContext);
    const { property } = props;
    const id = property[constants.GuiTarget] || props.id;
    const range = property[constants.GuiRange][constants._id];
    const disabled = !!property[constants.GuiDisabled];
    const applyOn = property[constants.GuiApplyOn] || 'blur';
    function handleFilterChange(value) {
        const prevState = (id && state.filters[id]) || [];
        if (!checkAppliedChanges(value, prevState))
            props.onFilterChange(id, value);
    }
    function handleCustomFilterChange(value) {
        props.onCustomFilterChange(range, value);
    }
    function renderCheckbox() {
        return (property[constants.GuiTarget] && (React.createElement(ControlledCheckboxFilter_1.default, { "aria-label": property[constants.GuiLabel] || '', key: id, id: id, handleCheckboxChange: handleFilterChange, value: state.filters[id] || [], disabled: disabled })));
    }
    function renderMultiSelect() {
        var _a;
        return property[constants.GuiTarget] && property[constants.GuiBare] ? (renderBareCombobox(true)) : (React.createElement(ControlledMultiSelectCombobox_1.default, { "aria-label": property[constants.GuiLabel] || '', id: id, key: id, value: ((_a = state.filters) === null || _a === void 0 ? void 0 : _a[id]) || [], options: property[constants.GuiValues] || [], searchable: property[constants.GuiSearchable], editable: property[constants.GuiEditable], labelSingular: property[constants.GuiSingular], labelPlural: property[constants.GuiPlural], labelMode: property[constants.GuiLabelMode], handleCheckboxChange: handleFilterChange, handleSearchTermChange: property[constants.GuiSearchFunction], handleSearchTermChangeDebounce: property[constants.GuiSearchFunctionDelay], customComponents: props.customComponents, disabled: disabled, disabledLabel: property[constants.GuiDisabledLabel], applyOn: applyOn, placeholder: property[constants.GuiPlaceholder] }));
    }
    function renderCombobox() {
        var _a;
        return property[constants.GuiTarget] && property[constants.GuiBare] ? (renderBareCombobox(false)) : (React.createElement(ControlledComboboxFilter_1.default, { "aria-label": property[constants.GuiLabel] || '', key: id, id: id, options: property['gui:values'] || [], handleComboBoxChange: handleFilterChange, value: state.filters[id] || [], disabled: disabled, showAny: !!property[constants.GuiShowAnyOption], anyOptionLabel: (_a = property[constants.GuiAnyOptionLabel]) !== null && _a !== void 0 ? _a : 'Any' }));
    }
    function renderBareCombobox(multiple) {
        var _a, _b, _c, _d;
        return (React.createElement(ControlledOptionGroup_1.default, { "aria-label": (_a = property[constants.GuiLabel]) !== null && _a !== void 0 ? _a : '', key: id, id: id, options: (_b = property[constants.GuiValues]) !== null && _b !== void 0 ? _b : [], handleComboBoxChange: handleFilterChange, customComponents: props.customComponents, value: (_c = state.filters[id]) !== null && _c !== void 0 ? _c : [], disabled: disabled, multiple: multiple, showAny: !multiple && !!property[constants.GuiShowAnyOption], anyOptionLabel: (_d = property[constants.GuiAnyOptionLabel]) !== null && _d !== void 0 ? _d : 'Any' }));
    }
    function renderDatePicker() {
        return (property[constants.GuiTarget] && (React.createElement(ControlledDatePickerFilter_1.default, { "aria-label": property[constants.GuiLabel] || '', "aria-labelledby": "myBillingId myNameId", key: id, id: id, handleDatePickerChange: handleFilterChange, value: state.filters[id] || [], disabled: disabled })));
    }
    function renderCustom() {
        const externalComponents = props.customFilters;
        const customId = property['gui:range']['@id'];
        if ((property[constants.GuiTarget] === undefined || property[constants.GuiTarget] === '') &&
            customId &&
            externalComponents) {
            const custom = externalComponents[customId];
            if (custom) {
                const customFilter = state.customFilters[customId] || [];
                return (React.createElement(ControlledCustomFilter_1.default, { key: customId, id: customId, custom: custom, value: customFilter, handleCustomFiltersChange: handleCustomFilterChange, disabled: disabled }));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        }
        return React.createElement(React.Fragment, null);
    }
    function renderSearchSubComponent() {
        switch (range) {
            case 'xsd:boolean':
                return renderCheckbox();
            case 'xsd:string':
                return property[constants.GuiMulti] ? renderMultiSelect() : renderCombobox();
            case 'xsd:date':
                return renderDatePicker();
            default:
                return renderCustom();
        }
    }
    function renderLabel() {
        const labelCustomId = property[constants.GuiLabelCustomID];
        return property[constants.GuiMain] ? null : (React.createElement(Label_1.default, { testId: 'filter-label', className: `${styles.filterLabel} ${constants_1.ANG_CSS_PREFIX}-filter-label`, htmlFor: id, id: id + '-label' },
            property[constants.GuiLabel] || '',
            labelCustomId && props.customComponents && props.customComponents[labelCustomId] && (React.createElement(CustomComponent_1.default, { "data-test-id": `label-custom-component-${labelCustomId}`, id: `${id}-label-${labelCustomId}`, custom: props.customComponents[labelCustomId] }))));
    }
    return (React.createElement("div", { "data-test-id": `test-${props.id}`, className: `${styles.filterPanel} ${constants_1.ANG_CSS_PREFIX}-filter-panel` },
        renderLabel(),
        renderSearchSubComponent()));
};
exports.default = ControlledFilter;
